var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");


var LocalZRotationModel = require("./localZRotationModel.js");
var LocalZRotationView = require("./localZRotationView.js");

var Editor3d = require("./../../editor3d/editor3dController.js");

var LocalZRotationController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);

};

lib_core.inherit(LocalZRotationController, lib_core.Controller);
LocalZRotationController.inject = {
    editor3d : Editor3d
};

module.exports = LocalZRotationController;

LocalZRotationController.prototype.handleId = "rotationLocalZ";

LocalZRotationController.prototype.createModel = function () {
    var editor3dModel = this.editor3d.getModel();

    return new LocalZRotationModel(editor3dModel, this.handleId, this.configuration);
};


LocalZRotationController.prototype.createView = function () {
    var editor3dView = this.editor3d.getView();

    return new LocalZRotationView(this.getModel(), editor3dView, this.handleId, this.configuration);
};



